"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Rect = void 0;
const Adapt_1 = require("../../modifiers/Adapt");
const ShapeBuffer_1 = require("../ShapeBuffer");
/**
 *
 * @category Shapes.ShapeBuffer
 * @class Rect
 * @extends {ShapeBuffer}
 */
class Rect extends ShapeBuffer_1.ShapeBuffer {
    /**
     * Creates an instance of Rect.
     *
     * @param {ShapeBaseSettings} [settings={}]
     * @memberof Rect
     */
    constructor(settings = {}) {
        settings.type = 'Rect';
        settings.shape = Rect.buffer;
        settings.adaptMode = Adapt_1.EAdaptMode.None;
        super(settings);
    }
}
exports.Rect = Rect;
Rect.buffer = Float32Array.from([1, 1, -1, 1, -1, -1, 1, -1]);
//# sourceMappingURL=Rect.js.map